import React, { useState, useCallback } from 'react';

/**
 * VirtualKeyboard - On-screen touch keyboard for kiosk displays.
 * Supports QWERTY layout with shift, backspace, space, and enter.
 * Designed for the UniFi Display which may not trigger a system keyboard.
 */
export default function VirtualKeyboard({ value, onChange, onSubmit, onClose }) {
  const [shifted, setShifted] = useState(false);

  const rows = [
    ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
    ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
    ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
    ['z', 'x', 'c', 'v', 'b', 'n', 'm'],
  ];

  const handleKey = useCallback((key) => {
    const char = shifted ? key.toUpperCase() : key;
    onChange(value + char);
    if (shifted) setShifted(false);
  }, [value, onChange, shifted]);

  const handleBackspace = useCallback(() => {
    onChange(value.slice(0, -1));
  }, [value, onChange]);

  const handleSpace = useCallback(() => {
    onChange(value + ' ');
  }, [value, onChange]);

  return (
    <div className="virtual-keyboard-overlay" onClick={onClose}>
      <div className="virtual-keyboard" onClick={(e) => e.stopPropagation()}>
        <div className="vk-input-preview">
          <span className="vk-label">Meeting Subject</span>
          <span className="vk-value">{value || ' '}<span className="vk-cursor">|</span></span>
        </div>

        {rows.map((row, i) => (
          <div key={i} className="vk-row">
            {i === 3 && (
              <button
                className={`vk-key vk-shift ${shifted ? 'vk-active' : ''}`}
                onClick={() => setShifted(!shifted)}
              >
                Shift
              </button>
            )}
            {row.map((key) => (
              <button
                key={key}
                className="vk-key"
                onClick={() => handleKey(key)}
              >
                {shifted ? key.toUpperCase() : key}
              </button>
            ))}
            {i === 3 && (
              <button className="vk-key vk-backspace" onClick={handleBackspace}>
                &#9003;
              </button>
            )}
          </div>
        ))}

        <div className="vk-row vk-bottom-row">
          <button className="vk-key vk-special" onClick={() => onChange(value + ',')}>
            ,
          </button>
          <button className="vk-key vk-special" onClick={() => onChange(value + '.')}>
            .
          </button>
          <button className="vk-key vk-space" onClick={handleSpace}>
            Space
          </button>
          <button className="vk-key vk-special" onClick={() => onChange(value + '-')}>
            -
          </button>
          <button className="vk-key vk-done" onClick={onClose}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
